<div
  class="contato-container"
  *ngIf="contatos?.companies?.length; else vazioMsg"
>
  <div *ngFor="let company of contatos?.companies" class="empresa-card">
    <div class="empresa-cabecalho">
      <mat-icon
        *ngIf="!company.companyLogoUrl"
        class="empresa-icone"
        fontSet="material-symbols-outlined"
        >apartment</mat-icon
      >
      <img
        *ngIf="company.companyLogoUrl"
        [src]="company.companyLogoUrl"
        alt="Logo da empresa"
        class="empresa-logo"
      />
      <div class="empresa-dados">
        <h4>
          <a
            [routerLink]="['/empresas/detalhes', rotaModulo, company.companyId]"
            class="empresa-link"
          >
            {{ company.companyTradeName }}
          </a>
          <span class="empresa-tipo" *ngIf="company.companyRoleAlias">{{
            company.companyRoleAlias
          }}</span>
        </h4>
        <p>
          <ng-container
            *ngIf="company.companyCNPJ && company.companyCNPJ !== '-'"
          >
            CNPJ: {{ company.companyCNPJ }}
            <span class="pipe">|</span>
          </ng-container>
          <a
            [routerLink]="['/empresas/detalhes', rotaModulo, company.companyId]"
            class="empresa-link"
            >{{ company.companyTotalWorks }} obra(s)</a
          >
          <ng-container
            *ngIf="company.companyPhone1 && company.companyPhone1 !== '-'"
          >
            <span class="pipe">|</span>
            <span class="info-linha">
              <mat-icon class="info-icone" fontSet="material-symbols-outlined"
                >call</mat-icon
              >
              {{ company.companyPhone1 }}
            </span>
          </ng-container>
          <ng-container
            *ngIf="company.companyPhone2 && company.companyPhone2 !== '-'"
          >
            <span class="pipe">|</span>
            <span class="info-linha">
              <mat-icon class="info-icone" fontSet="material-symbols-outlined"
                >call</mat-icon
              >
              {{ company.companyPhone2 }}
            </span>
          </ng-container>
        </p>
      </div>
    </div>

    <div class="contato-lista">
      <div *ngFor="let contato of company.contacts" class="contato-item">
        <div class="contato-avatar">
          {{ getIniciais(contato.contactName) }}
        </div>

        <div class="contato-info">
          <p class="contato-nome">
            <span class="contato-nome-texto">{{ contato.contactName }}</span>
            <span class="contato-cargo">{{ contato.contactRole }}</span>
          </p>
          <p
            class="contato-email info-linha"
            *ngIf="contato.contactEmail && contato.contactEmail !== '-'"
          >
            <mat-icon class="info-icone" fontSet="material-symbols-outlined"
              >mail</mat-icon
            >
            {{ contato.contactEmail }}
          </p>
          <p
            class="contato-telefone info-linha"
            *ngIf="contato.contactPhone1 && contato.contactPhone1 !== '-'"
          >
            <mat-icon class="info-icone" fontSet="material-symbols-outlined"
              >call</mat-icon
            >
            {{ contato.contactPhone1 }}
          </p>
        </div>

        <div class="contato-acoes">
          <a
            *ngIf="contato.contactEmail"
            [href]="'mailto:' + contato.contactEmail"
            title="Enviar e-mail"
            class="acao-link"
          >
            <mat-icon class="acao-icone" fontSet="material-symbols-outlined"
              >mail</mat-icon
            >
          </a>
          <a
            *ngIf="contato.contactPhone1 && contato.contactPhone1 !== '-'"
            [href]="getWhatsappLink(contato.contactPhone1)"
            target="_blank"
            rel="noopener noreferrer"
            title="Abrir WhatsApp"
            class="acao-link"
          >
            <svg
              class="acao-icone acao-icone-whatsapp"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"
              />
            </svg>
          </a>
          <button
            type="button"
            class="acao-btn"
            [disabled]="somenteLeitura"
            (click)="abrirAgendarTarefa(contato, company)"
            title="Agendar tarefa"
          >
            <mat-icon class="acao-icone" fontSet="material-symbols-outlined"
              >calendar_add_on</mat-icon
            >
          </button>
          <button
            type="button"
            class="acao-btn"
            [disabled]="somenteLeitura"
            (click)="abrirReportContato(contato, company)"
            title="Reportar erro no contato"
          >
            <mat-icon class="acao-icone" fontSet="material-symbols-outlined"
              >flag</mat-icon
            >
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #vazioMsg>
  <div class="contato-vazio">
    <p>Nenhum contato encontrado.</p>
  </div>
</ng-template>

<div
  class="modal-agendar-tarefa"
  *ngIf="isPanelOpen && currentPanel === 'agendar-tarefa'"
>
  <div class="modal-agendar-backdrop" (click)="closePanel()"></div>
  <div class="modal-agendar-content">
    <div class="modal-agendar-body">
      <app-agendar-tarefa
        [idObra]="idObra"
        [moduloId]="idModulo"
        (close)="closePanel()"
        [contatoInfo]="contatoSelecionado"
        (tarefaCriada)="atualizarListaTarefas($event)"
        (loading)="onPainelLoading($event)"
      ></app-agendar-tarefa>
    </div>
  </div>
</div>

<app-modal-reportar-erro-contato
  *ngIf="showReportContato && contatoParaReport"
  [contactId]="contatoParaReport?.contactId"
  [contactSource]="contatoParaReport?.contactSource ?? null"
  [sourceContactId]="contatoParaReport?.sourceContactId ?? null"
  [contactName]="contatoParaReport?.contactName"
  [contactRole]="contatoParaReport?.contactRole"
  [contactEmail]="contatoParaReport?.contactEmail"
  [contactPhone]="contatoParaReport?.contactPhone1"
  [constructorId]="empresaParaReport?.companyId"
  [constructorName]="empresaParaReport?.companyTradeName"
  [workId]="idObra"
  [workName]="workName"
  [moduleId]="idModulo"
  [module]="moduleName"
  [companyId]="companyId"
  [companyName]="companyName"
  (close)="fecharReportContato()"
  (loading)="onPainelLoading($event)"
></app-modal-reportar-erro-contato>
